<template>
  <div class="expert-think-tank profession">
    <div class="box_11">
      <div class="box_11-item" v-for="(expert, index) in expertList" :key="index" @click="goDetail(expert)">
        <img
          class="box_11-avatar"
          referrerpolicy="no-referrer"
          :src="expert.img"
        />
        <div class="box_11-info flex-col">
          <span class="box_11-name">{{ expert.name }}</span>
          <!-- <span class="box_11-org">{{ expert.descrip }}</span> -->
        </div>
      </div>
      <div class="empty-state" v-if="expertList.length === 0">
        <p class="empty-state-text">暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ExpertThinkTank',
  props: {
    experts: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    expertList() {
      if (this.experts && this.experts.length) {
        return this.experts
      }
      return []
    }
  },
  methods: {
    goDetail(expert) {
      if (expert && expert.id) {
        this.$router.push('/article/' + expert.id)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.profession {
  width: 100%;
  padding: 0 16px 0;
  box-sizing: border-box;
}
.box_11 {
  // width: 100% !important;
  margin-top: 11px;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;
  .box_11-item {
    display: inline-block;
    vertical-align: top;
    white-space: normal;
    width: 106px;
    margin-right: 10px;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 8px;
    padding-bottom: 8px;
    cursor: pointer;
    transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);

    &:active {
      transform: scale(0.95);
      opacity: 0.85;
    }

    .box_11-avatar {
      width: 106px;
      height: 96px;
      border-radius: 8px  8px 0px 0px;
    }
    .box_11-info {
      margin: 3px 5px 0 6px;
      .box_11-name {
        overflow: hidden;
        text-overflow: ellipsis;
        color: rgba(34, 34, 34, 1);
        font-size: 12px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        text-align: right;
        white-space: nowrap;
        line-height: 17px;
        margin: 0 34px 0 25px;
      }
      .box_11-org {
        width: 95px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(153, 153, 153, 1);
        font-size: 10px;
        text-align: left;
        line-height: 14px;
        margin-top: 3px;
      }
    }
    &--badge {
      .box_11-badge {
        width: 12px;
        height: 96px;
      }
      .box_11-badge-text {
        width: 6px;
        height: 28px;
        overflow-wrap: break-word;
        color: rgba(153, 153, 153, 1);
        font-size: 10px;
        text-align: left;
        line-height: 14px;
        margin: 23px 0 0 6px;
      }
    }
  }
}
</style>
